<!-- <div *ngIf="isSaving" class="progress-container">
    <div class="process-text">
        {{ currentProcessText }}
    </div>
    <div class="progress">
        <div class="progress-bar progress-bar-striped progress-bar-animated" [style.width.%]="progress" role="progressbar" aria-valuemin="0" aria-valuemax="100"></div>
    </div>
</div> -->
<mat-stepper [linear]="isSaving" labelPosition="bottom" #stepper [disableRipple]="true">
    <mat-step [stepControl]="firstFormGroup">
        <form [formGroup]="firstFormGroup">
            <ng-template matStepLabel>Datos de facturación</ng-template>
            <br>
            <app-wiz-facturacion    
                [accountForm]="accountForm" 
                [rfcAvailable]="rfcAvailable" 
                [razonSocialAvailable]
                (rfcAvailableChange)="onRfcAvailableChange($event)"
                (razonSocialAvailableChange)="onRazonSocialAvailableChange($event)">
            </app-wiz-facturacion>
            <br><br>
            <div class="text-right">
                <small><span class="text-danger">*</span> Campos requeridos</small>
            </div>
            <hr>
            <div class="text-right">
                <button mat-button class="btn btn-primary" [disabled]="isSaving" (click)="goToNextStep()">Siguiente</button>
            </div>
        </form>
    </mat-step>

    <mat-step [stepControl]="secondFormGroup">
        <form [formGroup]="secondFormGroup">
            <ng-template matStepLabel>Sellos digitales</ng-template>
            <br>
            <app-wiz-sellos [stampForm]="stampForm" (fileCerChange)="onFileCerChange($event)" (fileKeyChange)="onFileKeyChange($event)"></app-wiz-sellos>
            <hr>
            <div class="text-right">
                <button mat-button matStepperPrevious class="btn btn-primary" [disabled]="isSaving">Anterior</button>
                <button mat-button class="btn btn-primary" [disabled]="isSaving" (click)="goToNextStamp()">Siguiente</button>
            </div>
        </form>
    </mat-step>

    <mat-step [stepControl]="secondFormGroup"ß>
        <form [formGroup]="secondFormGroup">
            <ng-template matStepLabel>Lugar de expedición</ng-template>
            <br>
            <app-wiz-expedicion [lugarExpedicionForm]="lugarExpedicionForm" (cpValidChange)="handleCpValidation($event)"></app-wiz-expedicion>
            <hr>
            <div class="text-right">
                <button mat-button matStepperPrevious class="btn btn-primary" [disabled]="isSaving">Anterior</button>
                <button mat-button class="btn btn-primary" [disabled]="isSaving" (click)="goToNextExpedicion()">Siguiente</button>
            </div>
        </form>
    </mat-step>

    <mat-step>
        <ng-template matStepLabel>Finalizar</ng-template>
        <br>
        <app-wiz-done [opcionSeleccionada]="opcionSeleccionada" [nuevoUsuarioForm]="nuevoUsuarioForm" (opcionSeleccionadaChange)="onOpcionSeleccionadaChange($event)" (emailAvailableChange)="onEmailAvailableChange($event)" (existingUserIdChange)="onUsuarioSeleccionadoChange($event)"></app-wiz-done>

        <hr>
        <div class="text-right">
            <button mat-button matStepperPrevious class="btn btn-primary" [disabled]="isSaving">Anterior</button>
            <button mat-button class="btn btn-primary" [disabled]="isSaving" (click)="goToNextDone()">Finalizar</button>
        </div>
    </mat-step>
</mat-stepper>

<div *ngIf="isSaving" class="overlay">
    <div class="progress-container">
        <div class="process-text">
            {{ currentProcessText }}
        </div>
        <div class="progress">
            <div class="progress-bar progress-bar-striped progress-bar-animated" [style.width.%]="progress" role="progressbar" aria-valuemin="0" aria-valuemax="100"></div>
        </div>
    </div>
</div>